import { Box, Button, Tab, Tabs, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import {
  Settings_Module,
  Dashboard_Entity,
  Entity_Label,
  ModulePath,
  Super_Admin_Module,
} from "../../constant/ApplicationVariables";
import { useApplicationContext } from "../../context/ApplicationContext";
import { AddOutlined } from "@mui/icons-material";
import { font } from "../../styles/font";
import { lazy, useEffect } from "react";
import OrganisationContainer from "../organisation";
import SuperAdminContainer from "../super-admin";
import ActiveProject from "../projects/ActiveProject";

import MarketplaceDashboard from "../../components/marketplace/MarketplaceDashboard";
const ProjectsContainer = lazy(() => import("../projects"));
const AdminContainer = lazy(() => import("../admin"));
const ProgramContainer = lazy(() => import("../program"));

function ApplicationMainContainer() {
  const {
    activeDashboard,
    setActiveDashboard,
    handlePageDetails,
    activeSettingsModule,
    setActiveSettingsModule,
    activeSuperAdminModule,
    openCreateProjectDrawer,
    setOpenCreateProjectDrawer,
    openCreateUserDialog,
    setOpenCreateUserDialog,
    openCreateRoleDialog,
    setOpenCreateRoleDialog,
    openCreateProgramDrawer,
    setOpenCreateProgramDrawer,
    currentProgramData,
    setCurrentProgramData,
    openCreateTaskDialog,
    setOpenCreateTaskDialog,
    openCreateOrganisationDialog,
    setOpenCreateOrganisationDialog,
    openCreateLicenseDialog,
    setOpenCreateLicenseDialog,
    openCreateReportDialog,
    setOpenCreateReportDialog,
  } = useApplicationContext();
  const pathName = useLocation()?.pathname;
  const location = useLocation();

  const handleComponent = (path) => {
    switch (path) {
      case ModulePath.projects:
        return <ProjectsContainer />;
      case ModulePath.programmes:
        return <ProgramContainer />;
      case ModulePath.organisations:
        return <OrganisationContainer />;
         case ModulePath.marketplace:
        return <MarketplaceDashboard />;
      case ModulePath.settings:
        return <AdminContainer />;
      case ModulePath.superAdmin:
        return <SuperAdminContainer />;
      case ModulePath.requirements:
        return <ActiveProject />;
      case ModulePath.useCase:
        return <ActiveProject />;
      case ModulePath.testCase:
        return <ActiveProject />;
      case ModulePath.planning:
        return <ActiveProject />;
      case ModulePath.execution:
        return <ActiveProject />;
      case ModulePath.task:
        return <ActiveProject />;
      case ModulePath.regression:
        return <ActiveProject />;
      case ModulePath.dashboard:
        return <ActiveProject />;
      case ModulePath.configuration:
        return <ActiveProject />;

      default:
        return null;
    }
  };

  const handleOpenProjectCreateDialog = () => {
    setOpenCreateProjectDrawer(true);
  };

  const handleOpenUserCreateDialog = () => {
    setOpenCreateUserDialog(true);
  };

  const handleOpenRoleCreateDialog = () => {
    setOpenCreateRoleDialog(true);
  };

  const handleOpenProgramCreateDialog = () => {
    setOpenCreateProgramDrawer(true);
  };

  const handleOpenOrganisationCreateDialog = () => {
    setOpenCreateOrganisationDialog(true);
  };

  const handleOpenLicenseCreateDialog = () => {
    setOpenCreateLicenseDialog(true);
  };

  const handleOpenCreateDialog = () => {
    setOpenCreateTaskDialog(true);
  };

  const handleOpenCreateDashboardReportDialog = () => {
    setOpenCreateReportDialog(true);
  };

  // Listen for location state changes
  useEffect(() => {
    if (location.pathname === ModulePath.dashboard) {
      // Check if we have dashboard state in location
      if (location.state?.activeDashboard && setActiveDashboard) {
        console.log(
          "Setting dashboard from location state:",
          location.state.activeDashboard,
        );
        setActiveDashboard(location.state.activeDashboard);
      }
    }
  }, [location, setActiveDashboard]);

//   return (
//     <Box className="flex-1 flex flex-col gap-0 px-0 py-0 relative  overflow-hidden   ">
//       {/* module tabs for admin */}
//       {/* {pathName === ModulePath.settings && (
//                 <Box className="flex items-center gap-2 px-4 pt-4 pb-2">
//                     {
//                         [Local_Modules.dashboard, Local_Modules.license, Local_Modules.userManagement]?.map((item, index) => {
//                             return (
//                                 <Button key={index} variant={item === activeModule ? "outlined" : "text"} color={item === activeModule ? "secondary" : "primary"}>
//                                     {item}
//                                 </Button>
//                             )
//                         })
//                     }
//                 </Box>
//             )} */}

//       {/* page description  as no needed for title and description for each page*/}
//       {/* <Box className="flex items-center justify-between w-full h-fit px-4 py-4 "> */}

//       {/*this is the title and description of the pages test case and all ..*/}
//       {/* {handlePageDetails()?.title && (
//                     <Box className="flex-1 flex flex-col " sx={{ px: (pathName === ModulePath.projects || pathName === ModulePath.programmes || pathName === ModulePath.organisations) ? 4 : 0 }}>
//                         <Typography fontSize={font.size.fs_2} color="textPrimary" fontWeight={"bold"}>{handlePageDetails()?.title}</Typography>
//                         <Typography>{handlePageDetails()?.description}</Typography>
//                     </Box>
//                 )} */}

//       {/* <Box className="flex flex-col">
//                     {pathName === ModulePath.projects && (
//                         <Button startIcon={<AddOutlined />} variant="contained" color="secondary" onClick={handleOpenProjectCreateDialog}>Create {Entity_Label.project}</Button>
//                     )}
//                     {pathName === ModulePath.settings && (
//                         activeSettingsModule === Settings_Module.userManagement ? (
//                             <Button startIcon={<AddOutlined />} variant="contained" color="secondary" onClick={handleOpenUserCreateDialog}>Invite User</Button>
//                         ) : activeSettingsModule === Settings_Module.roleManagement ? (
//                             <Button startIcon={<AddOutlined />} variant="contained" color="secondary" onClick={handleOpenRoleCreateDialog}>Add Role</Button>
//                         ) : null
//                     )}
//                     {pathName === ModulePath.programmes && !currentProgramData && (
//                         <Button startIcon={<AddOutlined />} variant="contained" color="secondary" onClick={handleOpenProgramCreateDialog}>Create {Entity_Label.programme}</Button>
//                     )}


//                     {pathName === ModulePath.superAdmin && (
//                         activeSuperAdminModule === Super_Admin_Module.organisation ? (
//                             <Button startIcon={<AddOutlined />} variant="contained" color="secondary" onClick={handleOpenOrganisationCreateDialog}>Create {Entity_Label.organisation}</Button>
//                         ) : activeSuperAdminModule === Super_Admin_Module.license ? (
//                             <Button startIcon={<AddOutlined />} variant="contained" color="secondary" onClick={handleOpenLicenseCreateDialog}>Create License</Button>
//                         ) : null
//                     )}

//                     {pathName === ModulePath.task && (
//                         <Button variant="contained" color="secondary" startIcon={<AddOutlined />} onClick={handleOpenCreateDialog}>Create {Entity_Label.task}</Button>
//                     )} */}

//       {/* {pathName === ModulePath.dashboard && (
//                         activeDashboard === Dashboard_Entity.report.value ? (
//                             <Button startIcon={<AddOutlined />} variant="contained" color="secondary" onClick={handleOpenCreateDashboardReportDialog}>Create {Entity_Label.dashboardReport}</Button>
//                         ) : null
//                     )} */}
//       {/* 
//                 </Box>
//             </Box> */}

//       <Box className="flex-1 flex flex-col  px-0 py-0 pb-4 overflow-hidden ">
//         {handleComponent(pathName)}
//       </Box>
//     </Box>
//   );

return (
  <Box className="flex-1 flex flex-col gap-0 px-0 py-0 relative overflow-hidden">
    {/* Header action buttons only for Settings */}
    {pathName === ModulePath.settings && (
      <Box className="flex items-center justify-end w-full h-fit px-1 py-2">
        {/* Header action buttons */}
        {activeSettingsModule === Settings_Module.userManagement && (
          <Button
            startIcon={<AddOutlined />}
            variant="contained"
            onClick={handleOpenUserCreateDialog}
            sx={{
              mt: 0,
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 600,
              height: 40,
              px: 3,
              background:
                "linear-gradient(90deg, hsl(var(--cyan)), hsl(var(--emerald)))",
              color: "hsl(var(--primary-foreground))",
              boxShadow: "0 4px 14px hsl(var(--cyan) / 0.35)",
              "&:hover": {
                background:
                  "linear-gradient(90deg, hsl(var(--cyan) / 0.9), hsl(var(--emerald) / 0.9))",
                boxShadow: "0 6px 20px hsl(var(--cyan) / 0.45)",
              },
              "&:active": { transform: "scale(0.98)" },
            }}
          >
            Invite User
          </Button>
        )}
        {activeSettingsModule === Settings_Module.roleManagement && (
          <Button
            startIcon={<AddOutlined />}
            variant="contained"
            onClick={handleOpenRoleCreateDialog}
            sx={{
              mt: 0,
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 600,
              height: 40,
              px: 3,
              background:
                "linear-gradient(90deg, hsl(var(--cyan)), hsl(var(--emerald)))",
              color: "hsl(var(--primary-foreground))",
              boxShadow: "0 4px 14px hsl(var(--cyan) / 0.35)",
              "&:hover": {
                background:
                  "linear-gradient(90deg, hsl(var(--cyan) / 0.9), hsl(var(--emerald) / 0.9))",
                boxShadow: "0 6px 20px hsl(var(--cyan) / 0.45)",
              },
              "&:active": { transform: "scale(0.98)" },
            }}
          >
            Add Role 
          </Button>
        )}
      </Box>
    )}

    {/* Main content */}
    <Box className="flex-1 flex flex-col px-0 py-0 pb-4 overflow-hidden">
      {handleComponent(pathName)}
    </Box>
  </Box>
);


}

export default ApplicationMainContainer;
